"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleComponent = exports.titleComponent_WeightToJSON = exports.titleComponent_WeightFromJSON = exports.TitleComponent_Weight = exports.titleComponent_SizeToJSON = exports.titleComponent_SizeFromJSON = exports.TitleComponent_Size = exports.protobufPackage = void 0;
exports.protobufPackage = "title";
var TitleComponent_Size;
(function (TitleComponent_Size) {
    /** NOT_SET - sizing styles are not applied on the client (this variant should be avoided) */
    TitleComponent_Size[TitleComponent_Size["NOT_SET"] = 0] = "NOT_SET";
    TitleComponent_Size[TitleComponent_Size["ONE"] = 1] = "ONE";
    TitleComponent_Size[TitleComponent_Size["TWO"] = 2] = "TWO";
    TitleComponent_Size[TitleComponent_Size["THREE"] = 3] = "THREE";
    TitleComponent_Size[TitleComponent_Size["FOUR"] = 4] = "FOUR";
    TitleComponent_Size[TitleComponent_Size["FIVE"] = 5] = "FIVE";
    TitleComponent_Size[TitleComponent_Size["SIX"] = 6] = "SIX";
    TitleComponent_Size[TitleComponent_Size["SEVEN"] = 7] = "SEVEN";
    TitleComponent_Size[TitleComponent_Size["EIGHT"] = 8] = "EIGHT";
    TitleComponent_Size[TitleComponent_Size["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TitleComponent_Size || (exports.TitleComponent_Size = TitleComponent_Size = {}));
function titleComponent_SizeFromJSON(object) {
    switch (object) {
        case 0:
        case "NOT_SET":
            return TitleComponent_Size.NOT_SET;
        case 1:
        case "ONE":
            return TitleComponent_Size.ONE;
        case 2:
        case "TWO":
            return TitleComponent_Size.TWO;
        case 3:
        case "THREE":
            return TitleComponent_Size.THREE;
        case 4:
        case "FOUR":
            return TitleComponent_Size.FOUR;
        case 5:
        case "FIVE":
            return TitleComponent_Size.FIVE;
        case 6:
        case "SIX":
            return TitleComponent_Size.SIX;
        case 7:
        case "SEVEN":
            return TitleComponent_Size.SEVEN;
        case 8:
        case "EIGHT":
            return TitleComponent_Size.EIGHT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TitleComponent_Size.UNRECOGNIZED;
    }
}
exports.titleComponent_SizeFromJSON = titleComponent_SizeFromJSON;
function titleComponent_SizeToJSON(object) {
    switch (object) {
        case TitleComponent_Size.NOT_SET:
            return "NOT_SET";
        case TitleComponent_Size.ONE:
            return "ONE";
        case TitleComponent_Size.TWO:
            return "TWO";
        case TitleComponent_Size.THREE:
            return "THREE";
        case TitleComponent_Size.FOUR:
            return "FOUR";
        case TitleComponent_Size.FIVE:
            return "FIVE";
        case TitleComponent_Size.SIX:
            return "SIX";
        case TitleComponent_Size.SEVEN:
            return "SEVEN";
        case TitleComponent_Size.EIGHT:
            return "EIGHT";
        case TitleComponent_Size.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.titleComponent_SizeToJSON = titleComponent_SizeToJSON;
var TitleComponent_Weight;
(function (TitleComponent_Weight) {
    TitleComponent_Weight[TitleComponent_Weight["BOLD"] = 0] = "BOLD";
    /** REGULAR - frontend fallbacks to REGULAR if not provided */
    TitleComponent_Weight[TitleComponent_Weight["REGULAR"] = 1] = "REGULAR";
    TitleComponent_Weight[TitleComponent_Weight["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TitleComponent_Weight || (exports.TitleComponent_Weight = TitleComponent_Weight = {}));
function titleComponent_WeightFromJSON(object) {
    switch (object) {
        case 0:
        case "BOLD":
            return TitleComponent_Weight.BOLD;
        case 1:
        case "REGULAR":
            return TitleComponent_Weight.REGULAR;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TitleComponent_Weight.UNRECOGNIZED;
    }
}
exports.titleComponent_WeightFromJSON = titleComponent_WeightFromJSON;
function titleComponent_WeightToJSON(object) {
    switch (object) {
        case TitleComponent_Weight.BOLD:
            return "BOLD";
        case TitleComponent_Weight.REGULAR:
            return "REGULAR";
        case TitleComponent_Weight.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.titleComponent_WeightToJSON = titleComponent_WeightToJSON;
function createBaseTitleComponent() {
    return { hasDelimiter: false, text: "", size: 0, weight: 0 };
}
exports.TitleComponent = {
    fromJSON(object) {
        return {
            hasDelimiter: isSet(object.hasDelimiter) ? Boolean(object.hasDelimiter) : false,
            text: isSet(object.text) ? String(object.text) : "",
            size: isSet(object.size) ? titleComponent_SizeFromJSON(object.size) : 0,
            weight: isSet(object.weight) ? titleComponent_WeightFromJSON(object.weight) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.hasDelimiter === true) {
            obj.hasDelimiter = message.hasDelimiter;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.size !== 0) {
            obj.size = titleComponent_SizeToJSON(message.size);
        }
        if (message.weight !== 0) {
            obj.weight = titleComponent_WeightToJSON(message.weight);
        }
        return obj;
    },
    create(base) {
        return exports.TitleComponent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTitleComponent();
        message.hasDelimiter = object.hasDelimiter ?? false;
        message.text = object.text ?? "";
        message.size = object.size ?? 0;
        message.weight = object.weight ?? 0;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=title.js.map